import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const SearchInput = ({ initialQuery = '', onSearch, onQueryChange }) => {
  const [query, setQuery] = useState(initialQuery);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  // Mock suggestions data
  const mockSuggestions = [
    "Sarah Johnson",
    "Michael Rodriguez",
    "Emily Chen",
    "David Thompson",
    "Jessica Williams",
    "Alex Martinez",
    "Rachel Brown",
    "James Wilson"
  ];

  useEffect(() => {
    setQuery(initialQuery);
  }, [initialQuery]);

  useEffect(() => {
    if (query?.length > 0) {
      const filtered = mockSuggestions?.filter(name =>
        name?.toLowerCase()?.includes(query?.toLowerCase())
      )?.slice(0, 5);
      setSuggestions(filtered);
      setShowSuggestions(filtered?.length > 0);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  }, [query]);

  const handleInputChange = (e) => {
    const value = e?.target?.value;
    setQuery(value);
    onQueryChange?.(value);
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (query?.trim()) {
      onSearch(query?.trim());
      setShowSuggestions(false);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setQuery(suggestion);
    onSearch(suggestion);
    setShowSuggestions(false);
  };

  const handleInputFocus = () => {
    if (suggestions?.length > 0) {
      setShowSuggestions(true);
    }
  };

  const handleInputBlur = () => {
    // Delay hiding suggestions to allow click events
    setTimeout(() => setShowSuggestions(false), 150);
  };

  return (
    <div className="relative w-full max-w-2xl mx-auto">
      <form onSubmit={handleSubmit} className="relative">
        <div className="relative">
          <Icon 
            name="Search" 
            size={20} 
            className="absolute left-4 top-1/2 transform -translate-y-1/2 text-muted-foreground"
          />
          <Input
            type="search"
            placeholder="Search for people on Aether..."
            value={query}
            onChange={handleInputChange}
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            className="pl-12 pr-12 py-3 text-base bg-surface border-border rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-150"
          />
          {query && (
            <button
              type="button"
              onClick={() => {
                setQuery('');
                onQueryChange?.('');
                setShowSuggestions(false);
              }}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors"
            >
              <Icon name="X" size={18} />
            </button>
          )}
        </div>
      </form>
      {/* Search Suggestions */}
      {showSuggestions && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-popover border border-border rounded-xl shadow-elevation-2 z-50 animate-slide-up">
          <div className="py-2">
            {suggestions?.map((suggestion, index) => (
              <button
                key={index}
                onClick={() => handleSuggestionClick(suggestion)}
                className="flex items-center w-full px-4 py-3 text-left hover:bg-muted transition-colors duration-150"
              >
                <Icon name="Search" size={16} className="mr-3 text-muted-foreground" />
                <span className="text-foreground">{suggestion}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchInput;